import React, { useContext, useEffect, useRef, useState,  } from "react";
import { Tag, TagSuggestion } from 'react-tag-autocomplete';
import SimpleBar from "simplebar-react";

//context
import { ContentAudienceContext } from "./ContentAudienceContext";

//hooks
import useDebounce from "@/components/hooks/useDebounce";

//components
import AutocompleteWithTags from "../global/textInputs/AutocompleteWithTags";
import CheckboxPanel from "../global/dropdown/CheckboxPanel";

//api
import { getAudienceGroupsForEdit } from  "@/api/contentAudience";

// interface
import { AudienceModalState } from "@/interfaces/ContentAudienceModal";



const FilterControlsWrapper = ({ handleToggleFilter }) => {

    const {contentId, setGroupFilters, audienceModalState, currentSelection, filterOptions} = useContext(ContentAudienceContext)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [selected, setSelected] = useState<Tag[]>([]);
    const [suggestions, setSuggestions] = useState<TagSuggestion[]>([])
    const [input, setInput] = useState<string>('');

    const debouncedTerm:string = useDebounce(input, 500);

    const scrollableNodeRef = useRef<any>();

    useEffect(() => {
        const positioningInterval = showGroupFilter() 
        ? setInterval(() => {
            const container = (scrollableNodeRef.current as HTMLElement)?.getBoundingClientRect();
            if(document?.querySelector?.('.react-tags__listbox') as HTMLElement) {

                (document?.querySelector?.('.react-tags__listbox') as HTMLElement).style.top = `${container.top + 65}px`
            }
        }, 200)
        : undefined

        return () => {
            clearInterval(positioningInterval);
        }
    }, [])

    useEffect(() => {
        setIsLoading(true)
        getAudienceGroupsForEdit(contentId, {SearchTerm: debouncedTerm, sortBy: 'groupsName', sort: 'asc', top:20, skip: 0, filter:{filterOptions: [], filterGroups:[]}}).then(({records}) => {
            setSuggestions(records.map(group => ({label: group.name, value: group.id})))
        })
        .finally(() => {
            setIsLoading(false)
        });

    },[debouncedTerm])

    function showGroupFilter() {
        return audienceModalState == AudienceModalState.EditAudience && currentSelection === 'Users'
    }

    useEffect(() => {
        if(scrollableNodeRef?.current){
            scrollableNodeRef.current.scrollTop = scrollableNodeRef.current.scrollHeight;
        }
        setGroupFilters(selected.map(selectedGroup => String(selectedGroup.value)))
    }, [selected])

    return <section className='filter-controls-wrapper'>
        <CheckboxPanel 
            panelTitle={'Includes'} 
            items={[{
                id: 1, 
                content:`Archived ${currentSelection}`,
                isSelected: filterOptions.includes('includeInactive'),
                onCheck: () => handleToggleFilter('includeInactive')
            }]} 
        />
        
        {showGroupFilter() && 
            <div className="auto-complete-tags-wrapper">
            
                <p className="checkbox-list-title">Groups</p>
                <SimpleBar className={'react-tags-wrapper'} style={{height: 60, maxHeight: 60}} scrollableNodeProps={{ ref: scrollableNodeRef }}>
                    <AutocompleteWithTags 
                        selected={selected}
                        setSelected={setSelected}
                        suggestions={suggestions}
                        setSuggestions={setSuggestions}
                        noOptionsText={isLoading ? "searching.." : "No matching groups"}
                        placeholderText="Search by group name"
                        input={input}
                        setInput={setInput}
                        closeOnScrollTarget={document.querySelector('.fullpage-modal') as HTMLElement}
                    />       
                </SimpleBar>
            </div>
        }
        
    </section>
}

export default FilterControlsWrapper